export function truncateProjectName(name: string, maxLength: number): string {
  return name.slice(0, maxLength);
}
